import { DropdownButton, DropdownButtonContext } from '@dixa/lib-shared-habla';
import type { PhoneNumber } from 'lib-shared-legacy-types';
import { formatInternational } from 'lib-shared-phone-numbers';

import OwnNumbersDropDownButton from 'components/shared/ownNumbersDropDownButton/containers/ownNumbersDropDownButton';
import type { GetNumbersByQueryPayloadT } from 'components/telephony/api/types';

import '../styles/call-flow.less';

type PhoneNumberSelectProps = {
  className: string;
  disabled?: boolean;
  phoneNumber: string;
  changePhoneNumber: (number: PhoneNumber) => void;
  getPhoneNumbersByQuery: (payload: GetNumbersByQueryPayloadT) => void;
};

export const PhoneNumberSelect = ({
  className,
  disabled,
  phoneNumber,
  changePhoneNumber,
  getPhoneNumbersByQuery,
}: PhoneNumberSelectProps): JSX.Element => {
  const buttonLabel = formatInternational(phoneNumber) || 'Select a number';

  return (
    <DropdownButton
      id="select-number-dropdown"
      className={className ?? ''}
      buttonProps={{
        disabled,
        className: 'select-number-dropdown-toggle',
      }}
      dropdown={
        <DropdownButtonContext.Consumer>
          {({ toggleDropdown, dropdownOpen }) => (
            <ul
              role="menu"
              className="dropdown-menu"
              aria-labelledby="select-number-dropdown"
            >
              <OwnNumbersDropDownButton
                changeDefaultNumber={changePhoneNumber}
                currentDefaultNumber={phoneNumber}
                getNumbersByQuery={getPhoneNumbersByQuery}
                open={dropdownOpen}
                toggleDropdown={toggleDropdown}
              />
            </ul>
          )}
        </DropdownButtonContext.Consumer>
      }
    >
      {buttonLabel}
    </DropdownButton>
  );
};
